import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReportesService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';
type ReportMode = 'SUPPLIER_SIMPLE' | 'SUPPLIER_EXTENDED' | 'FUNDER' | 'EMPTY';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-bbva',
  templateUrl: './bbva.component.html',
  styles: []
})
export class BbvaComponent implements OnInit {
  reportMode: ReportMode = 'EMPTY';
  // data holders
  supplierSimpleData: any[] = [];
  supplierExtendedText = '';
  funderData: any = null;
  extendido = false;
  cadenaRespuesta = {};
  fecharepor: string;
  empresaSeleccionada = 'na';

  constructor(private _reportesservice: ReportesService) { }

  facturas: any[] = [];
  usuario: string;
  cols: any[];
  colspdf: any[];
  selectedFac: any[];
  router: Router;
  fileName = 'Simple.xlsx';
  selectedColumnsp: any[];
  selectedColumnspdf: any[];
  exportColumns: any[];
  companieswrecurso: any[];
  muestracompanies = false;
  _selectedColumns: any[];

  ngOnInit() {
    this.muestracompanies = false;
    this._reportesservice.getpayment_with_recourse_companies().subscribe(r => {this.companieswrecurso = r;});
    setTimeout(() => {
      this._reportesservice.getGeneralParam('BBVA_PAYMENT_REPORT_MODE').subscribe(r => {
        if (r['value'] === 'EXTENDIDO') {
          this.extendido = true;
        }
        })
    }, 1000);
  }


  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    // restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  muestraonocompanies(e) {
    if (e === 'aforo') {
      this.muestracompanies = true;
    } else {
      this.muestracompanies = false;
    }
  }

generarReporte() {
this.reportMode = 'EMPTY';
  swal2.fire({
    title: 'Cargando',
    allowOutsideClick: false
  });
  swal2.showLoading();
  const curr: any = document.getElementById('curr');
  const valorCurr = curr.options[curr.selectedIndex].value;
  const d = new Date((document.getElementById('fechaconsulta')as HTMLInputElement).value);
  d.setMinutes( d.getMinutes() + d.getTimezoneOffset() );
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) {
        month = '0' + month;
    }
  if (day.length < 2) {
        day = '0' + day;
    }
  this.fecharepor = [year, month, day].join('-');
  const type = ((document.getElementById('type')as HTMLInputElement).value);
  if (type.toLowerCase() === 'aforo') {
    const idc = ((document.getElementById('compa')as HTMLInputElement).value);
    console.log(idc)
    console.log(valorCurr);
    console.log(this.fecharepor);
    this._reportesservice.getBaseAforo(this.fecharepor, valorCurr, idc).subscribe(resp => {this.facturas = resp;
      swal2.close();
      if ( this.facturas.length === 0 ) {
        swal2.fire(
          'No se encontraron datos con la información proporcionada',
          '',
          'info'
          );
      } else {
        // tslint:disable-next-line: forin
        for (const prop in this.facturas) {
        // this.facturas[prop].importe = this.facturas[prop].importe.replace(/^(0+)/g, '');
          this.facturas[prop].importe = this.facturas[prop].importe.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
      }
    }, (err) => {
      swal2.close();
      console.log(err);
      swal2.fire(
      'Error al Consultar los Datos',
      '',
      'error'
      );
      this.ngOnInit();
    } );
  } else {
    this._reportesservice.getBbva(this.fecharepor, valorCurr, type, this.empresaSeleccionada).subscribe(resp => {
      if (resp.length === 0) {
        swal2.fire('No se encontraron datos','','info');
        return;
      }
      swal2.close();
          // limpiar objetos
          this.reportMode = 'EMPTY';
          this.supplierSimpleData = [];
          this.supplierExtendedText = '';
          this.funderData = null;

          // ---SUPPLIER ---
          if (type === 'supplier') {
                  // EXTENDIDO
            if (this.extendido) {
              this.reportMode = 'SUPPLIER_EXTENDED';
              this.supplierExtendedText = resp.join('\n');
              return;
            } else {
                // SIMPLE
                  this.reportMode = 'SUPPLIER_SIMPLE';
                  this.supplierSimpleData = resp;
                  return;

            }
          }
          // --- CASE 3: FUNDER (placeholder) ---
          if (type === 'funder') {
              this.reportMode = 'FUNDER';
              this.funderData = resp;
              return;
          }
          }, (err) => {
          swal2.close();
          console.log(err);
          swal2.fire(
          'Error al Consultar los Datos',
          '',
          'error'
          );
          } );
  }
}
  // supplier extendido txt
  exportTxtExtended() {
  const blob = new Blob([this.supplierExtendedText], { type: 'text/plain;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'extendido.txt';
  a.click();

  window.URL.revokeObjectURL(url);
}
// supplier simple txt
exportTxtFromTable() {
  const content = this.supplierSimpleData
    .map(r => `${ r.clave_proveedor } ${ r.cuenta_cargo } ${ r.fecha_de_pago } ${ r.importe } ${ r.moneda } ${ r.motivo_pago } ${ r.ref_numerica } ${ r.texto_libre } ${ r.tipo_cta } ${ r.tipo_de_operacion }`)
    .join('\n');

  const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'simple.txt';
  a.click();

  URL.revokeObjectURL(url);
}
// supplier simple excel
exportSupplierSimpleExcel() {
     const datos = this.supplierSimpleData.map(data => ({
       'Clave proveedor': data.clave_proveedor,
       'Cuenta cargo': data.cuenta_cargo,
       'Fecha de pago': data.fecha_de_pago,
       'Importe': data.importe,
       'Moneda': data.moneda,
       'Motivo pago': data.motivo_pago,
       'Referencia numerica': data.ref_numerica,
       'Texto libre': data.texto_libre,
       'Tipo cuenta': data.tipo_cta,
       'Tipo de operacion': data.tipo_de_operacion
     }));
   
     const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datos);
   
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'simple');
   
     XLSX.writeFile(wb, this.fileName);
}

// funder txt
exportFunderTxt() {
  const content = this.funderData
    .map(r => `${ r.cuenta_cargo } ${ r.cuenta_destino } ${ r.destinatario } ${ r.divisa } ${ r.iva } ${ r.payment_report_folio } ${ r.referencia } ${ r.referencia_concepto } ${ r.referencia_numerica } ${ r.rfc_destinatario } ${r.tipo_operacion}`)
    .join('\n');

  const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'fsimple.txt';
  a.click();

  URL.revokeObjectURL(url);
}
// funder excel
exportFunderExcel() {
     const datos = this.funderData.map(data => ({
       'Cuenta cargo': data.cuenta_cargo,
       'Cuenta destino': data.cuenta_destino,
       'Destinatario': data.destinatario,
       'Divisa': data.divisa,
       'IVA': data.iva,
       'Folio': data.payment_report_folio,
       'Referencia': data.referencia,
       'Referencia concepto': data.referencia_concepto,
       'Referencia numerica': data.referencia_numerica,
       'RFC destinatario': data.rfc_destinatario,
       'Tipo operacion': data.tipo_operacion
     }));
   
     const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datos);
   
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'fsimple');
   
     XLSX.writeFile(wb, 'Fsimple.xlsx');
}

}
